export default {
  online_shop: 'Negozio online',
  storefront: 'Vetrina',
  reservations: 'Prenotazioni',
  import: 'Importazione',
};
